import { Typography } from "@mui/material";
import { TypographyProps } from "./typography-props";


export default function H2({children, ...props}: TypographyProps) {
  return <Typography variant="h2" {...props}>{children}</Typography>
}